import React from 'react';

const TotalHead: React.FC = () => {
  return <div style={{ textAlign: 'left' }}>Total</div>;
};

export { TotalHead };
